/* PureState footer v2 (sections/ps-footer.liquid): (1) link groups are <details> accordions on mobile and always open
   from 990px (the summary toggle is disabled there); (2) after a successful e-mail capture (data-ps-captured, server
   rendered) the offer pop-up's ps_offer_done cookie is written so the pop-up stays away like after a pop-up capture.
   No Romanian literals. */
(function () {
  'use strict';
  var footer = document.querySelector('[data-ps-footer]');
  if (!footer) return;

  /* ---- groups ---- */
  var groups = Array.prototype.slice.call(footer.querySelectorAll('[data-ps-footer-group]'));
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var accordion = footer.classList.contains('ps-footer--accordion');
  function sync() {
    var desktop = !mq || mq.matches;
    groups.forEach(function (d) {
      if (desktop) {
        d.open = true;
        d.classList.add('ps-footer__group--desktop');
        var sum = d.querySelector('summary');
        if (sum) { sum.setAttribute('tabindex', '-1'); sum.setAttribute('aria-disabled', 'true'); }
      } else {
        d.classList.remove('ps-footer__group--desktop');
        var sm = d.querySelector('summary');
        if (sm) { sm.removeAttribute('tabindex'); sm.removeAttribute('aria-disabled'); }
        if (accordion && d.dataset.psUserOpened !== '1') d.open = false;
      }
    });
  }
  groups.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (mq && mq.matches) { if (!d.open) d.open = true; return; }
      d.dataset.psUserOpened = d.open ? '1' : '0';
    });
  });
  sync();
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  /* ---- capture → suppress the offer pop-up ---- */
  if (footer.querySelector('[data-ps-captured]')) {
    var days = parseInt(footer.dataset.suppressDays || '365', 10) || 365;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    try {
      document.cookie = 'ps_offer_done=1; max-age=' + (days * 86400) + '; path=/; SameSite=Lax' + secure;
      document.cookie = 'ps_offer_closed=; max-age=0; path=/; SameSite=Lax' + secure;
    } catch (e) { /* cookies blocked: nothing to do */ }
  }
})();
